function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 40,
  r: 40,
  fill: "#1F252E"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M46.5 18.5v12h12",
  stroke: "#fff",
  strokeWidth: 3,
  strokeLinecap: "square"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M58.5 40.5v-11l-11-11h-25v44h23M30.5 52.5h5M30.5 42.5h8M30.5 32.5h8M60.5 60.5l-6.05-6.051",
  stroke: "#fff",
  strokeWidth: 3,
  strokeLinecap: "square"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M49.5 56.5a7 7 0 100-14 7 7 0 000 14z",
  stroke: "#fff",
  strokeWidth: 3,
  strokeLinecap: "square"
});

var SvgRoleCurator = function SvgRoleCurator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODAiIGhlaWdodD0iODAiIHZpZXdCb3g9IjAgMCA4MCA4MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iNDAiIGN5PSI0MCIgcj0iNDAiIGZpbGw9IiMxRjI1MkUiLz4KPHBhdGggZD0iTTQ2LjUgMTguNVYzMC41SDU4LjUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMyIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIvPgo8cGF0aCBkPSJNNTguNSA0MC41VjI5LjVMNDcuNSAxOC41SDIyLjVWNjIuNUg0NS41IiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjMiIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiLz4KPHBhdGggZD0iTTMwLjUgNTIuNUgzNS41IiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjMiIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiLz4KPHBhdGggZD0iTTMwLjUgNDIuNUgzOC41IiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjMiIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiLz4KPHBhdGggZD0iTTMwLjUgMzIuNUgzOC41IiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjMiIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiLz4KPHBhdGggZD0iTTYwLjUwMDIgNjAuNUw1NC40NDkyIDU0LjQ0OSIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIzIiBzdHJva2UtbGluZWNhcD0ic3F1YXJlIi8+CjxwYXRoIGQ9Ik00OS41IDU2LjVDNTMuMzY2IDU2LjUgNTYuNSA1My4zNjYgNTYuNSA0OS41QzU2LjUgNDUuNjM0IDUzLjM2NiA0Mi41IDQ5LjUgNDIuNUM0NS42MzQgNDIuNSA0Mi41IDQ1LjYzNCA0Mi41IDQ5LjVDNDIuNSA1My4zNjYgNDUuNjM0IDU2LjUgNDkuNSA1Ni41WiIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIzIiBzdHJva2UtbGluZWNhcD0ic3F1YXJlIi8+Cjwvc3ZnPgo=";
export { SvgRoleCurator as ReactComponent };